import { ReactNode } from "react";
import { Theme } from "@mui/material/styles";
import { Box, BoxProps as IBoxProps, SxProps } from "@mui/material";
import { generalStyles } from "src/utils/cssStyles";
import { TableFilterWrapperContext } from "./TableFilterWrapperContext";

const { flexColumnStyle } = generalStyles;

interface TableFilterWrapperProps extends IBoxProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const TableFilterWrapper = ({
  children,
  sx,
  ...other
}: TableFilterWrapperProps) => {
  return (
    <TableFilterWrapperContext.Provider value={true}>
      <Box
        sx={[
          {
            ...flexColumnStyle,
            border: "1px solid",
            borderColor: "text.borderLine",
            borderRadius: 2,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...other}
      >
        {children}
      </Box>
    </TableFilterWrapperContext.Provider>
  );
};

interface IHeaderProps extends IBoxProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const Header = ({ children, sx, ...other }: IHeaderProps) => {
  return (
    <Box
      sx={[
        {
          px: 2,
          py: 1,
          borderBottom: "1px solid",
          borderColor: "text.borderLine",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </Box>
  );
};

interface IContentProps extends IBoxProps {
  children: ReactNode;
}

const Content = ({ children, ...other }: IContentProps) => {
  return <Box {...other}>{children}</Box>;
};

TableFilterWrapper.Header = Header;
TableFilterWrapper.Content = Content;
